export const chartTheme = {
  axisStroke: "#E2E8F0",
  axisTickFill: "#64748B",
  axisTickFontSize: 11,
  gridStroke: "#F1F5F9",
  gridDasharray: "0",
  lineStrokeWidth: 2,
  dotRadius: 0,
  activeDotRadius: 4,
  // gradient fill — soft pastel
  areaGradientFromOpacity: 0.25,
  areaGradientToOpacity: 0.0,
  // tooltip — white card
  tooltipBg: "#FFFFFF",
  tooltipBorder: "1px solid #E2E8F0",
  tooltipShadow: "0 4px 12px rgba(15,23,42,0.08), 0 0 0 1px rgba(15,23,42,0.04)",
  tooltipPadding: "8px 12px",
  tooltipRadius: 6,
  fontFamily: '"Inter",-apple-system,"Segoe UI",Roboto,sans-serif',
} as const;
